import React from "react";
import { useParams } from "react-router-dom";
import ProfileView from "../../components/profile/ProfileView";
import { useAuth } from "../../contexts/AuthContext";

// Read-only profile of another user (reached from a mode's owner).
const UserProfile = () => {
  const { id } = useParams();
  const { user } = useAuth();
  return <ProfileView userId={id} isOwn={id === user?._id} />;
};

export default UserProfile;
